import { RootState } from "../store";
import { Status } from "../types/state";
import { getFieldOrdering } from "../utils/ordering";

export const getBillingLocations = (state: RootState) => state.billingLocations;
export const getBillingLocationsStatus = (state: RootState) => state.billingLocations.status;
export const getIsBillingLocationsStatusLoading = (state: RootState): boolean =>
  state.billingLocations.status !== Status.success;

export const getBillingLocationsErrorMsg = (state: RootState) => state.billingLocations.errorMsg;

export const getBillingLocationsList = (state: RootState) => state.billingLocations.list;

export const getBillingLocationsPagination = (state: RootState) => state.billingLocations.pagination;
export const getBillingLocationsOrdering = (state: RootState) => state.billingLocations.ordering;
export const getBillingLocationsFilterValue = (state: RootState, filterId: string) =>
  state.billingLocations.filters.items.find((item) => item.id === filterId);

export const getBillingLocationsSearch = (state: RootState) => state.billingLocations.search;

export const getBillingLocationsScrollTop = (state: RootState) => state.billingLocations.scrollTop;

export const getBillingLocationsOrderingValue = (state: RootState, fieldName: string) => {
  const ordering = state.billingLocations.ordering;
  return getFieldOrdering(fieldName, ordering);
};

export const getBillingLocationsFilterIsActive = (state: RootState, fieldName: string) =>
  !!state.billingLocations.filters.items.find((item) => String(item.id).startsWith(fieldName));
